import config from '@config/index';
import { useScreenPhone } from '@goodfynd/theme';
import { IconButton, Logo } from '@goodfynd/ui';
import { NoSsr } from '@mui/material';
import classnames from 'clsx';

import { Navigation } from './Navigation';
import { useSidebar } from './SidebarContext';

import classes from './Sidebar.module.css';

export const Sidebar = () => {
  const { isCollapsed, toggleSidebar } = useSidebar();
  const isPhone = useScreenPhone();

  return (
    <NoSsr>
      <div
        className={classnames(classes['sidebar-container'], {
          [classes.collapsed]: isCollapsed,
        })}
      >
        {!isPhone && (
          <div className={classes['logo-container']}>
            <Logo
              badgePosition="bottom"
              environment={config.env.NAME_LOWER}
              height={isCollapsed ? 37 : 22}
              isCollapsed={isCollapsed}
              type="vendors"
              width={isCollapsed ? 24 : 210}
            />
          </div>
        )}

        <div className={classes['sidebar-content']}>
          <Navigation isCollapsed={isCollapsed} />
        </div>

        <div
          className={classnames(classes['sidebar-bottom'], {
            [classes['sidebar-bottom-collapsed']]: isCollapsed,
          })}
        >
          <IconButton
            display="compact"
            icon={isCollapsed ? 'arrow_right' : 'arrow_left'}
            onClick={toggleSidebar}
          />
        </div>
      </div>
    </NoSsr>
  );
};
